<template>
    <div class="solicitor-Customer-case-details-tab">
        <div class="card-table rounded-bottom">
            <b-form role="form">
                <b-row>
                  <b-col md="8" cols="12">
                    <b-form-group label="Professional Fees">
                      <b-form-input v-model="form.professional_fees" required disabled></b-form-input>
                    </b-form-group>
                  </b-col>
                  <!-- Product Type input -->
                  <b-col md="8" cols="12">
                    <b-form-group label="Reimbursement">
                      <b-form-input v-model="form.reimbursement" required disabled></b-form-input>
                    </b-form-group>
                  </b-col>
                  <!-- Disbursement Input -->
                    <b-col md="8" cols="12">
                      <b-form-group label="Disbursement">
                        <b-form-input type="number" v-model="form.disbursement" required disabled></b-form-input>
                      </b-form-group>
                    </b-col>
                    <!-- Estimate Product Value Input -->
                    <b-col md="8" cols="12">
                      <b-form-group label="Subtotal">
                        <b-form-input type="number" v-model="form.sub_total" required disabled></b-form-input>
                      </b-form-group>
                    </b-col>
                    <!-- Estimate Product Value Input -->
                    <b-col md="8" cols="12">
                      <b-form-group label="SST (8%)">
                        <b-form-input type="number" v-model="form.sst" required disabled></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Subtotal (after SST)">
                            <b-form-input
                            v-model="form.Sub_total_after_sst"
                            type="number"
                            disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Discount Percentage">
                            <b-form-input
                            v-model="form.discount_percentage"
                            type="number"
                            disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Discount on Professional Fees">
                            <b-form-input
                            v-model="form.discount_on_professional_fees"
                            type="number"
                            disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Estimated Grand Total">
                            <b-form-input
                            v-model="form.estimated_grand_total"
                            type="number"
                            disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton, Button } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader,
    debounce
} from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'

export default {
    props: ['product'],
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        CurrencyInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
        [Button.name]: Button,
    },
    data() {
        return {
            is_loading: false,
            form: {
                professional_fees: '',
                reimbursement: '',
                disbursement: '',
                sub_total: '',
                sst: '',
                Sub_total_after_sst: '',
                discount_percentage: '',
                discount_on_professional_fees: '',
                estimated_grand_total: ''
            },
        }
    },
    watch:{
        product: {
            handler(newVal){
                this.form.professional_fees = newVal.product_detail.prod_sol_prof_fees || ''; 
                this.form.reimbursement = newVal.product_detail.prod_sol_reimburse || ''; 
                this.form.disbursement = newVal.product_detail.prod_sol_disburse || '';
                this.form.sub_total =  newVal.product_detail.prod_sol_sub_bef_sst || '';
                this.form.sst =  newVal.product_detail.prod_sol_sst || '';
                this.form.Sub_total_after_sst = newVal.product_detail.prod_sol_sub_aft_sst || ''; 
                this.form.discount_percentage = newVal.product_detail.prod_sol_disc_percent || ''; 
                this.form.discount_on_professional_fees = newVal.product_detail.prod_sol_discount || ''; 
                this.form.estimated_grand_total = newVal.product_detail.prod_sol_estimate_total || '';
            },
            immediate: true
        },
    },
    computed:{
        ...mapState(useAuthStore, ['auth_user']),
    },
  }
  </script>